import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations';
import '../styles/WhatIsBankL.css';

const WhatIsBankL = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="about" className="what-is-section">
      <div className="section-container">
        <h2>{t.whatIsTitle}</h2>
        <p className="section-description">{t.whatIsDesc}</p>
        
        <h3>{t.pillarsTitle}</h3>
        <div className="pillars">
          <div className="pillar">
            <div className="pillar-icon">🏦</div>
            <h4>{t.pillar1Title}</h4>
            <p>{t.pillar1Desc}</p>
          </div>
          <div className="pillar">
            <div className="pillar-icon">🪪</div>
            <h4>{t.pillar2Title}</h4>
            <p>{t.pillar2Desc}</p>
          </div>
          <div className="pillar">
            <div className="pillar-icon">🔁</div>
            <h4>{t.pillar3Title}</h4>
            <p>{t.pillar3Desc}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatIsBankL;